import { rankingItems } from '@/mocks/homeData';

const trendDisplay: Record<string, string> = {
  up: '↑',
  hot: '🔥',
  new: '🆕',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            人气榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500">本周最受观众喜爱的影视作品排行</p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-xl overflow-hidden">
          {rankingItems.map((item, index) => (
            <a
              key={item.id}
              href="#cards"
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 hover:bg-primary-50/50 transition-colors duration-200 cursor-pointer ${
                index < rankingItems.length - 1 ? 'border-b border-secondary-100' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-white'
                  : item.rank === 2
                  ? 'bg-secondary-400 text-white'
                  : item.rank === 3
                  ? 'bg-secondary-300 text-white'
                  : 'bg-secondary-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 truncate">{item.title}</h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-200 text-secondary-700 whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-400">{trendDisplay[item.trend]}</span>
                <span className="text-sm md:text-base font-bold text-accent-600">{item.score}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}